import { Component, effect, inject, input, InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DarkModeStore } from '../../../services/api/dark-mode/dark-mode-store.service';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'aw-dark-mode-toggle',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './dark-mode-toggle.component.html',
  styles: '',
})
export class DarkModeToggleComponent {
  public readonly darkModeStore: DarkModeStore = inject(DarkModeStore);

  setDarkModeValue(value: boolean) {
    this.darkModeStore.save(value);
    this.darkModeStore.loadDarkMode();
  }
}
